import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import axios from "axios";
import { ArrowLeft, Calendar } from "lucide-react";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import SEO from "@/components/SEO";
import { useLanguage } from "@/contexts/LanguageContext";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function BlogPostPage() {
  const { slug } = useParams();
  const { t, lang } = useLanguage();
  const [post, setPost] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get(`${API}/posts/${slug}`)
      .then(res => setPost(res.data))
      .catch(console.error)
      .finally(() => setLoading(false));
  }, [slug]);

  if (loading) return (
    <div style={{ background: "#050505", minHeight: "100vh" }}>
      <Navbar />
      <div style={{ paddingTop: "8rem", textAlign: "center" }}>
        <p style={{ color: "#52525B", fontFamily: "Unbounded, sans-serif", fontSize: "0.7rem", letterSpacing: "0.2em" }}>{t.common.loading}</p>
      </div>
    </div>
  );

  if (!post) return (
    <div style={{ background: "#050505", minHeight: "100vh" }}>
      <Navbar />
      <div style={{ paddingTop: "8rem", textAlign: "center" }}>
        <p style={{ color: "#52525B" }}>Článek nenalezen</p>
        <Link to="/aktuality" style={{ color: "#FF005A" }}>← {t.common.back}</Link>
      </div>
    </div>
  );

  const title = lang === "en" && post.title_en ? post.title_en : post.title;
  const content = lang === "en" && post.content_en ? post.content_en : post.content;

  return (
    <div style={{ background: "#050505", minHeight: "100vh" }}>
      <SEO
        title={title}
        description={(content || "").replace(/<[^>]+>/g, "").slice(0, 160) || `Aktuality kapely Rebelky — ${title}`}
        url={`/aktuality/${post.slug || post._id}`}
        image={post.image_url}
        type="article"
      />
      <Navbar />
      <div style={{ paddingTop: "5rem" }}>
        {post.image_url && (
          <div style={{ width: "100%", maxHeight: "500px", overflow: "hidden", position: "relative" }}>
            <img src={post.image_url} alt={title} style={{ width: "100%", height: "100%", objectFit: "cover", opacity: 0.6 }} />
            <div style={{ position: "absolute", inset: 0, background: "linear-gradient(to bottom, transparent 50%, #050505 100%)" }} />
          </div>
        )}
        <div className="max-w-3xl mx-auto px-6 py-12">
          <Link
            to="/aktuality"
            data-testid="back-to-blog"
            className="flex items-center gap-2 mb-8"
            style={{ color: "#A1A1AA", fontFamily: "Unbounded, sans-serif", fontSize: "0.6rem", letterSpacing: "0.15em", textDecoration: "none" }}
          >
            <ArrowLeft size={14} /> {t.common.back}
          </Link>

          <div className="flex items-center gap-4 mb-6">
            <span style={{ background: "rgba(255,0,90,0.1)", border: "1px solid rgba(255,0,90,0.3)", color: "#FF005A", padding: "0.2rem 0.6rem", fontFamily: "Unbounded, sans-serif", fontSize: "0.5rem", letterSpacing: "0.15em" }}>
              {t.blog.categories[post.category] || post.category}
            </span>
            <div className="flex items-center gap-1">
              <Calendar size={13} style={{ color: "#52525B" }} />
              <span style={{ color: "#52525B", fontSize: "0.8rem" }}>
                {new Date(post.published_at).toLocaleDateString(lang === "cz" ? "cs-CZ" : "en-GB", { day: "numeric", month: "long", year: "numeric" })}
              </span>
            </div>
          </div>

          <h1 style={{ fontFamily: "Unbounded, sans-serif", fontWeight: 900, fontSize: "clamp(1.5rem, 4vw, 2.5rem)", color: "#FFFFFF", textTransform: "uppercase", lineHeight: 1.2, marginBottom: "2rem" }}>
            {title}
          </h1>

          <div style={{ color: "#A1A1AA", fontSize: "1rem", lineHeight: 1.8, fontFamily: "Manrope, sans-serif" }}>
            {content.split("\n").map((p, i) => p ? <p key={i} style={{ marginBottom: "1rem" }}>{p}</p> : <br key={i} />)}
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}
